import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { withAxios } from 'op/components/auth';
import { withOnlineStatus } from 'op/components/offline';
import { withErrorHandling } from 'op/components/error';

export const withAuditDetails = compose(
	withAxios,
	withErrorHandling,
	withOnlineStatus,
	withState('loading', 'setLoading', true),
	withState('audit', 'setAudit', null),
	withState('kpiData', 'setKpiData', []),
	withState('kpiNames', 'setKpiNames', []),
	withState('isKPIMng', 'setIsKPIMng', false),
	withState('auditStatuses', 'setAuditStatuses', []),
	withState('mainStatuses', 'setMainStatuses', []),
	withState('auditPersons', 'setAuditPersons', []),
	withState('isFollowupMng', 'setIsFollowupMng', false),
	withState('auditFollowups', 'setAuditFollowups', []),
	withState('followupTypes', 'setFollowupTypes', []),
	withHandlers({
		fetchAudit: function(props) {
			var setLoading = props.setLoading;
			var setAudit = props.setAudit;
			var setKpiData = props.setKpiData;
			var setKpiNames = props.setKpiNames;
			var setIsKPIMng = props.setIsKPIMng;
			var setAuditStatuses = props.setAuditStatuses;
			var setMainStatuses = props.setMainStatuses;
			var setAuditPersons = props.setAuditPersons;
			var setIsFollowupMng = props.setIsFollowupMng;
			var setAuditFollowups = props.setAuditFollowups;
			var setFollowupTypes = props.setFollowupTypes;
			var axios = props.axios;
			var throwError = props.throwError;
			var match = props.match;

			return async function() {
				setLoading(true);
				try {
					var response = await axios.get('/api/Audit/getMainAuditById?mainAuditId=' + match.params.audit_id);
					var auditData = response.data;
					setAudit(auditData);

					var statusPromises = [
						axios.get('/api/Audit/getAuditStatuses?mainAuditId=' + match.params.audit_id),
						axios.get('/api/Audit/getMainStatuses')
					];
					var statusResults = await Promise.all(statusPromises);
					setAuditStatuses(statusResults[0].data || []);
					setMainStatuses(statusResults[1].data || []);

					// Fetch audit persons with names
					try {
						var personsRes = await axios.get('/api/Audit/getAuditPersons?mainAuditId=' + match.params.audit_id);
						var savedPersons = personsRes.data || [];
						if (savedPersons.length > 0 && auditData.rdS_Unit_ID) {
							var unitPersonsRes = await axios.get('/api/Audit/getPersonsByUnit?unitId=' + auditData.rdS_Unit_ID);
							var unitPersonsList = unitPersonsRes.data || [];
							var mergedPersons = savedPersons.map(function(ap) {
								var personId = ap.rdS_Person_ID || ap.RDS_Person_ID;
								var unitPerson = unitPersonsList.find(function(up) {
									return (up.rdS_Person_ID || up.RDS_Person_ID) === personId;
								});
								var firstName = unitPerson ? (unitPerson.rdS_Person_FirstName || unitPerson.RDS_Person_FirstName || '') : '';
								// var middleName = unitPerson ? (unitPerson.rdS_Person_MiddleName || unitPerson.RDS_Person_MiddleName || '') : '';
								var lastName = unitPerson ? (unitPerson.rdS_Person_LastName || unitPerson.RDS_Person_LastName || '') : '';
							 return {
									RDS_Person_ID: personId,
									personName: (firstName +  ' ' + lastName + '(' + personId + ')').trim() || ('Person #' + personId),
									RDS_TrainingEventCategory_ID: ap.rDS_TrainingEventCategory_ID || ap.RDS_TrainingEventCategory_ID || null,
									RDS_TrainingEventType_ID: ap.rDS_TrainingEventType_ID || ap.RDS_TrainingEventType_ID || null,
									TrainingEventCategory_Name: ap.trainingEventCategory_Name || ap.TrainingEventCategory_Name || '',
									TrainingEventType_Name: ap.trainingEventType_Name || ap.TrainingEventType_Name || '',
									INS_MainAudit2PersonFollowupAlert: ap.inS_MainAudit2PersonFollowupAlert || ap.INS_MainAudit2PersonFollowupAlert || false,
									INS_MainAudit2PersonFollowupRemarks: ap.inS_MainAudit2PersonFollowupRemarks || ap.INS_MainAudit2PersonFollowupRemarks || '',
									INS_MainAudit2PersonFollowupResultDate: ap.inS_MainAudit2PersonFollowupResultDate || ap.INS_MainAudit2PersonFollowupResultDate || null,
								};
							});
							setAuditPersons(mergedPersons);
						} else {
							setAuditPersons([]);
						}
					} catch (e) {
						setAuditPersons([]);
					}

					if (auditData && auditData.inS_SubCategoryID) {
						var catResponse = await axios.get('/api/Audit/getMainCategories');
						var categories = catResponse.data || [];

						var mainCat = categories.find(function(c) {
							return c.inS_MainCategoryName === auditData.inS_MainCategoryName;
						});

						if (mainCat && mainCat.inS_MainCategoryIsFollowupMng) {
							setIsFollowupMng(true);

							try {
								var followupTypesRes = await axios.get('/api/Audit/getFollowupTypes');
								setFollowupTypes(followupTypesRes.data || []);
							} catch (e) {
								setFollowupTypes([]);
							}

							try {
								var followupsRes = await axios.get('/api/Audit/getMainAuditFollowups?mainAuditId=' + match.params.audit_id);
								setAuditFollowups(followupsRes.data || []);
							} catch (e) {
								setAuditFollowups([]);
							}
						}

						if (mainCat && mainCat.inS_MainCategoryIsKPIMng) {
							setIsKPIMng(true);

							var names = [];
							if (mainCat.inS_MainCategoryKPI1Name) names.push({ index: 1, name: mainCat.inS_MainCategoryKPI1Name });
							if (mainCat.inS_MainCategoryKPI2Name) names.push({ index: 2, name: mainCat.inS_MainCategoryKPI2Name });
							if (mainCat.inS_MainCategoryKPI3Name) names.push({ index: 3, name: mainCat.inS_MainCategoryKPI3Name });
							if (mainCat.inS_MainCategoryKPI4Name) names.push({ index: 4, name: mainCat.inS_MainCategoryKPI4Name });
							if (mainCat.inS_MainCategoryKPI5Name) names.push({ index: 5, name: mainCat.inS_MainCategoryKPI5Name });
							setKpiNames(names);

							var kpiTypesRes = await axios.get('/api/Audit/getKpiTypes?subCategoryId=' + auditData.inS_SubCategoryID);
							var kpiTypes = kpiTypesRes.data || [];

							var kpiRes = await axios.get('/api/Audit/getAuditKpis?mainAuditId=' + match.params.audit_id);
							var savedKpis = kpiRes.data || [];

							var merged = kpiTypes.map(function(kpiType) {
								var typeId = kpiType.inS_KPITypeID || kpiType.INS_KPITypeID;
								var saved = savedKpis.find(function(s) {
									return (s.inS_KPITypeID || s.INS_KPITypeID) === typeId;
								});
								return {
									INS_KPITypeID: typeId,
									kpiTypeName: kpiType.inS_KPITypeName || kpiType.INS_KPITypeName,
									kpiTypeDescription: kpiType.inS_KPITypeDescription || kpiType.INS_KPITypeDescription || '',
									INS_MainCategoryKPI: saved ? (saved.inS_MainCategoryKPI || saved.INS_MainCategoryKPI || 0) : 0,
									INS_MainAuditKPIRemarks: saved ? (saved.inS_MainAuditKPIRemarks || '') : '',
									INS_MainAuditKPIFollowup: saved ? (saved.inS_MainAuditKPIFollowup || '') : '',
									INS_MainAuditKPIFollowupResult: saved ? (saved.inS_MainAuditKPIFollowupResult || '') : '',
									INS_MainAuditKPIFollowupAlert: saved ? (saved.inS_MainAuditKPIFollowupAlert || false) : false,
									INS_MainAuditKPIFollowupDate: saved && (saved.inS_MainAuditKPIFollowupDate != null || saved.INS_MainAuditKPIFollowupDate != null) ? (saved.inS_MainAuditKPIFollowupDate || saved.INS_MainAuditKPIFollowupDate) : null,
								};
							});
							setKpiData(merged);
						}
					}
				} catch (e) {
					throwError({
						message: 'Unable to Fetch Audit Details',
						details: e.message + '; ' + e.stack,
					});
				}
				setLoading(false);
			};
		},
		downloadFile: function(props) {
			var axios = props.axios;
			var match = props.match;

			return async function(fileType, fileName) {
				try {
					var response = await axios.get('/api/Audit/downloadFile?mainAuditId=' + match.params.audit_id + '&fileType=' + fileType, {
						responseType: 'blob'
					});

					var url = window.URL.createObjectURL(new Blob([response.data]));
					var link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', fileName || fileType);
					document.body.appendChild(link);
					link.click();
					link.remove();
					window.URL.revokeObjectURL(url);
				} catch (e) {
					console.error('Download failed:', e);
				}
			};
		}
	}),
	lifecycle({
		componentDidMount: function() {
			if (this.props.online) {
				this.props.fetchAudit();
			} else {
				this.props.setLoading(false);
			}
		}
	}),
);
